import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class ScreenTabletFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'rectangle';
    this.parentButton = WBUtils.buttonAdvanced;
  }

  /**
     * Creates and returns a fabric path object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    let tabletPath = 'M27.125,0H6.867C5.59,0,4.562,1.033,4.562,2.309v29.377c0,1.272,1.028,2.308,2.305,2.308h20.258 ';
    tabletPath += 'c1.273,0,2.306-1.035,2.306-2.308V2.309C29.433,1.033,28.399,0,27.125,0z M16.997,';
    tabletPath += '33.129c-0.758,0-1.371-0.613-1.371-1.37 c0-0.758,0.613-1.372,1.371-1.372c0.756,0,1.371,0.614,1.371,1.372C18.368,';
    tabletPath += '32.516,17.753,33.129,16.997,33.129z  M27.098,29.186 H6.896V2.774h20.202V29.186z ';

    this.shapeObject = new fabric.Path(tabletPath);
    this.shapeObject.set({
      left: anchorX,
      top: anchorY,
      fill: 'rgba(0,0,0,0)',
      stroke: color,
      strokeWidth: stroke / 20
    });
    this.shapeObject.scaleToWidth(5);

    return this.shapeObject;
  }

  /**
     * modifies the path object expanding it to position (eventX/eventY), also checks
     * the direction of movement with position (anchorX, anchorY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    if (anchorX > eventX) {
      this.shapeObject.set({
        left: Math.abs(eventX)
      });
    }
    if (anchorY > eventY) {
      this.shapeObject.set({
        top: Math.abs(eventY)
      });
    }

    this.shapeObject.scaleToWidth(Math.abs(anchorX - eventX));
    this.shapeObject.setCoords();
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
